import { useLocation } from "react-router-dom";

const CustomFarewellMessage__solicitud_postergacion_estudios_2023 = () => (
  <div className="d-flex flex-column align-items-center">
    <p>
      La Dirección de Secretaría de Estudios y Gestión Curricular revisará y contactará en caso de
      ser necesario.
    </p>
    <p>
      Cualquier duda o consulta respecto del proceso de postergación de estudios puede comunicarse a{" "}
      <a href="mailto:secretariadeestudios@ulagos.cl">secretariadeestudios@ulagos.cl</a>
    </p>
  </div>
);

const SurveySentScreen = () => {
  const location = useLocation();
  const { originSurveyRoute } = location.state ?? "";

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="text-center p-2">Sus respuestas han sido enviadas</h1>
        {originSurveyRoute === "solicitud-postergacion-estudios-2023" ? (
          <CustomFarewellMessage__solicitud_postergacion_estudios_2023 />
        ) : (
          <h3 className="text-center">Muchas gracias por su participación.</h3>
        )}{" "}
      </div>
    </div>
  );
};

export default SurveySentScreen;
